import styled from 'styled-components';

export const InputWrapper = styled.div`
	display: inline-flex;
	flex-direction: row;
	align-items: flex-end;
	flex: 1;
	width: 50%;
	margin-bottom: 19px;
	&:nth-child(odd) {
		padding-right: 32px;
	}

	&:nth-child(even) {
		padding-left: 32px;
	}
`;
